module.exports = __webpack_public_path__ + "static/media/icon-close--circle.2c474420.svg";